import CityPageTemplate from "../city-template/CityPageTemplate";
import { moreheadConfig } from "./data";

export default function MoreheadPage() {
  return <CityPageTemplate config={moreheadConfig} />;
}